import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-4xl mx-auto relative rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20styled%20scene%20of%20neatly%20folded%20neutral%20and%20olive%20tone%20clothing%20stacked%20on%20a%20light%20wood%20shelf%20with%20a%20pair%20of%20white%20sneakers%20below%20and%20a%20woven%20basket%20and%20dried%20flowers%20nearby%2C%20soft%20golden%20natural%20light%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20cozy%20premium%20aesthetic&width=1600&height=700&seq=final-cta&orientation=landscape&nocache=true"
          alt="Basetao Spreadsheet final call to action"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40" />
        <div className="relative z-10 text-center px-6 py-16 md:py-20">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white">
            {t("finalCtaTitle")}
          </h2>
          <p className="mt-4 max-w-xl mx-auto text-sm md:text-base text-white/85 leading-relaxed">
            {t("finalCtaText")}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="mt-7 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("finalCtaButton")}
            <i className="ri-arrow-right-up-line text-base" />
          </a>
        </div>
      </div>
    </section>
  );
}